const rexMatch = /^[-\+]?(\d*\.\d+|\d+\.?)/;
const rexParse = new RegExp(rexMatch.source + "$");

export default {
    match: function(string) {
        const match = string.match(rexMatch);
        if (match === null) {
            return null;
        }

        return {
            "match": Number(match[0]),
            "tail": string.slice(match[0].length)
        };
    },

    parse: function(string) {
        const num = Number(string);
        if (num === num && rexParse.test(string)) {
            return num;
        }
        return null;
    }
};




// WEBPACK FOOTER //
// ./src/abusesa-js/formats/number.js